<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <settings
        v-bind:title="resource('TemplateColumnImageSettings_Settings_Title')"
        v-bind:region="'right'"
        v-bind:tooltip="tooltip"
        class="column-content-settings image-settings"
    >
        <template v-slot:body>
            <settings-media-picker
                class="form-group"

                v-bind:label="resource('TemplateColumnImageSettings_MediaId_Label')"
                v-bind:media-id="model.mediaId"
                @file-picked="model.mediaId = $event"
            >
            </settings-media-picker>
            
            <settings-media-cropper
                class="form-group"
                
                v-if="hasImage"
                v-bind:label="resource('TemplateManager_Shared_OpenMediaCropper_Button_Text')"
                v-bind:media-id="model.mediaId"
                
                @image-cropped="imageCropped($event.mediaId, $event.crop)"
            >
            </settings-media-cropper>
            
            <settings-slider
                v-bind:label="resource('TemplateManager_Shared_Size_Label')"
                v-model="model.style.size"
                
                v-bind:min="0"
                v-bind:max="100"
                
                v-bind:value-suffix="'%'"
            >
            </settings-slider>
            
            <settings-position
                v-bind:label="resource('TemplateManager_Shared_Position_Label')"
                v-model="model.style.position"
            >
            </settings-position>
            
            <settings-textbox
                v-bind:label="resource('TemplateManager_Shared_TooltipText_Label')"
                v-model="model.tooltip"
            >
            </settings-textbox>
            
            <settings-textbox
                v-bind:label="resource('TemplateManager_Shared_Link_Label')"
                v-model="model.link"
            >
            </settings-textbox>
            
            <settings-rotation
                v-bind:label="resource('TemplateManager_Shared_RotateImage_Label')"
                @rotate="addRotation"
            ></settings-rotation>
        </template>
    </settings>
</template>

<script>
    import _ from 'lodash';
    import $ from 'jquery';
    import mediaApi from '../../../../Api/media-library';

    import {imageContentSettingsTooltip} from "../../tooltips";

    import settingsMixin from '../../Mixins/settings';
    import resourceMixin from '../../../../Util/Mixins/resources';
    
    export default {
        name: "template-column-image-settings",
        mixins: [settingsMixin, resourceMixin],
        created(){
            this.currentRotation = this.model.rotation;
        },
        methods: {
            addRotation(rotation){
                const vm = this;
                
                //Calculate our new rotation
                rotation += vm.currentRotation;
                
                //Ensure a positive rotation by subtracting rotation from the absolute max when we would go below 0
                if(rotation < 0){
                    rotation = 360 + rotation
                }

                //Reset rotation when model rotation would exceed 360
                if(rotation >= 360){
                    rotation = 0;
                }
                
                vm.currentRotation = rotation;
            },
            imageCropped(mediaId, crop){
                const vm = this;
                
                vm.model.mediaId = mediaId;
                vm.model.crop = crop;
            },
            saveMediaEdit(){
                const vm = this;
                const $body = $(document.body);
                
                $body.addClass('cursor-progress');

                mediaApi.editImage(vm.model.mediaId, {
                    rotation: vm.currentRotation,
                    crop: vm.model.crop
                })
                .finally(() => $body.removeClass('cursor-progress'))
                .then(mediaId => {
                    vm.model.rotation = vm.currentRotation;
                    vm.model.mediaId = mediaId;
                });
            }
        },
        watch: {
            currentRotation: _.debounce(function(value){
                const vm = this;
                
                //Image is already properly rotated
                if(vm.model.rotation === value){
                    return;
                }
                
                vm.saveMediaEdit();
            }, 500)
        },
        data: () => ({
            tooltip: imageContentSettingsTooltip,
            currentRotation: 0
        }),
        computed: {
            hasImage(){
                const vm = this;
                
                return !!vm.model.mediaId;
            }
        }
    };
</script>
